import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=1bab2d68&scoped=true"
import script from "./inicio.vue?vue&type=script&lang=ts"
export * from "./inicio.vue?vue&type=script&lang=ts"
import style0 from "./inicio.vue?vue&type=style&index=0&id=1bab2d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab2d68",
  null
  
)

export default component.exports